<template>
    <div :class="'mb-3 db-counter ' + computed_col" v-show="runSleep">
        <div :class="'card ' + computed_bg">
            <div class="card-body d-flex justify-content-between align-items-center p-3">
                <div>
                    <a v-if="href" :href="href">
                        <h5 class="title m-0">{{title}}</h5>
                    </a>
                    <h5 v-else class="title m-0">{{title}}</h5>
                    <p class="subtitle m-0">{{subtitle}}</p>
                </div>
                <h2 :class="'number m-0 ' + (modal ? 'pointer' : '')" 
                    v-show="!loading" @click="openModal">
                    {{(data.number || data.number == 0) ? data.number : number}}
                </h2>
                <spinner-clip-loader v-show="loading"></spinner-clip-loader>
            </div>
        </div>
    </div>

</template>

<script>
import Axios from 'axios';
import spinnerClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
    components: {
        spinnerClipLoader
    },
    props: [
        'col',
        'title',
        'subtitle',
        'number',
        'bg',
        'trigger',
        'route',
        'sleep',
        'href',
        'modal',
    ],
    data() { return {
        data: {},
        runSleep: false,
        loading: false,
    }},
    computed: {
        computed_col() {
            if(this.col == undefined) {
                return 'col-xs-12 col-sm-6 col-lg-4';
            } else if(this.col == 'auto') {
                return 'col';
            } else if(this.col == 'false') {
                return '';
            } else {
                this.col;
            }
        },
        computed_bg() {
            if(this.bg == undefined) {
                return '';
            } else {
                return 'db-bg-'+this.bg;
            }
        },
    },
    mounted() {
        const vm = this;
        const disparador = $('#'+this.trigger);

        if(this.sleep == 'true' || this.sleep == true) {
            this.runSleep = false;
        } else {
            this.runSleep = true;
            vm.loading = true;
            vm.preGet(disparador);
        }

        disparador.on('submit', function() {
            vm.loading = true;
            vm.preGet(disparador);
        });
    },
    methods: {
        preGet(disparador) {
            const params = {};
            const data = disparador.serializeArray();
            data.forEach(item => {
                params[item.name] = item.value;
            });
            this.get(params);
        },
        get(data) {
            Axios.get(this.route, {params: data}).then(res => {
                this.data = res.data;
                this.runSleep = true;
                this.loading = false;
            }).catch(e => {
                console.log(e);
                this.loading = false;
            });
        },
        navegar() {
            if(this.href) {
                window.location.href = this.href;
            }
        },
        openModal() {
            if(this.modal) {
                $('#'+this.modal).modal('show');
            }
        }
    }
}
</script>